<template>
  <div class="help-center">
    <el-tabs v-model="tab">
      <el-tab-pane label="业务流程" name="flow">
        <div class="biz-flow">
          <div class="intro">
            <h2>系统业务流程</h2>
            <p>从基础配置到施工履约、材料人工协同，再到业主端服务，按下面主线推进即可。详细逐步操作见「操作手册」页签。</p>
          </div>

          <section class="flow-block">
            <div class="flow-title">一、主流程（装企日常）</div>
            <div class="flow-row">
              <div class="node primary">
                <div class="n-step">1</div>
                <div class="n-name">基础配置</div>
                <div class="n-desc">项目管理：房型设置 · 工序设置 · 评价设置 <br/> 基础资料： 供应商 · 材料 · 工人</div>
              </div>
              <div class="arrow">→</div>
              <div class="node primary">
                <div class="n-step">2</div>
                <div class="n-name">创建项目</div>
                <div class="n-desc">选房型生成项目计划 <br/> 指定项目经理 <br/> 邀请码绑定客户</div>
              </div>
              <div class="arrow">→</div>
              <div class="node primary">
                <div class="n-step">3</div>
                <div class="n-name">施工履约</div>
                <div class="n-desc">工序开工 / 完成 <br/> 发通知 <br/> 业主确认 <br/> 业主评价</div>
              </div>
              <div class="arrow">→</div>
              <div class="node primary">
                <div class="n-step">4</div>
                <div class="n-name">材料 &amp; 人工</div>
                <div class="n-desc">材料申请 <br/> 收退货 <br/> 工资申请与确认</div>
              </div>
              <div class="arrow">→</div>
              <div class="node primary">
                <div class="n-step">5</div>
                <div class="n-name">交付售后</div>
                <div class="n-desc">售后单处理 <br/> 投诉建议回复</div>
              </div>
            </div>
          </section>

          <section class="flow-block">
            <div class="flow-title">二、三端怎么配合</div>
            <div class="roles">
              <div class="role-card">
                <div class="role-head pc">PC 管理端</div>
                <ul>
                  <li>配置模板、档案、组织权限</li>
                  <li>建项目、看进度、管材料人工</li>
                  <li>发邀请码、处理售后 / 投诉</li>
                  <li>运营：活动、案例、内容</li>
                </ul>
              </div>
              <div class="role-card">
                <div class="role-head app">现场 App</div>
                <ul>
                  <li>项目经理：工序、通知、收货、派工</li>
                  <li>工人：工期、考勤、工资相关</li>
                  <li>供应商：看申请单、退货协同</li>
                  <li>项目签到、工地照片</li>
                </ul>
              </div>
              <div class="role-card">
                <div class="role-head mp">业主小程序</div>
                <ul>
                  <li>绑定公司 / 项目后看进度</li>
                  <li>确认工序通知、提交评价</li>
                  <li>浏览案例活动、收藏</li>
                  <li>发起售后、投诉建议</li>
                </ul>
              </div>
            </div>
            <div class="role-flow">
              <span class="chip pc">PC 配置 &amp; 建项</span>
              <span class="arr">→</span>
              <span class="chip app">App 现场执行</span>
              <span class="arr">→</span>
              <span class="chip mp">小程序业主确认评价</span>
              <span class="arr">→</span>
              <span class="chip pc">PC 售后闭环</span>
            </div>
          </section>

          <section class="flow-block">
            <div class="flow-title">三、材料 / 人工协同细流</div>
            <div class="sub-flows">
              <div class="sub-flow">
                <div class="sub-label">材料</div>
                <div class="sub-steps">
                  <span>材料价格表</span>
                  <i>→</i>
                  <span>材料申请</span>
                  <i>→</i>
                  <span>供应商处理</span>
                  <i>→</i>
                  <span>现场收货</span>
                  <i>→</i>
                  <span>退货（可选）</span>
                </div>
              </div>
              <div class="sub-flow">
                <div class="sub-label">人工</div>
                <div class="sub-steps">
                  <span>工人价格表</span>
                  <i>→</i>
                  <span>派工 / 工期</span>
                  <i>→</i>
                  <span>工资申请</span>
                  <i>→</i>
                  <span>确认 / 结算</span>
                </div>
              </div>
            </div>
          </section>

          <section class="flow-block last">
            <div class="flow-title">四、业主怎么进来</div>
            <div class="flow-row compact">
              <div class="node soft">
                <div class="n-name">PC 生成邀请码</div>
              </div>
              <div class="arrow">→</div>
              <div class="node soft">
                <div class="n-name">扫码 / 输码绑定</div>
              </div>
              <div class="arrow">→</div>
              <div class="node soft">
                <div class="n-name">看进度 · 确认通知</div>
              </div>
              <div class="arrow">→</div>
              <div class="node soft">
                <div class="n-name">评价 · 售后 · 建议</div>
              </div>
            </div>
            <p class="hint">搜索进入小程序且未绑定公司时，需先绑定装饰公司才能查看专属项目与服务。</p>
          </section>
        </div>
      </el-tab-pane>
      <el-tab-pane label="操作手册" name="manual">
        <user-manual />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import UserManual from './UserManual.vue'

export default {
  name: 'HelpBizFlow',
  components: { UserManual },
  data() {
    return {
      tab: 'flow'
    }
  },
  created() {
    // 仅首次进入时读 query，切换页签不再改路由，避免 TagsView 按 fullPath 重复开页签
    const t = this.$route.query.tab
    if (t === 'manual' || t === 'flow') this.tab = t
  }
}
</script>

<style scoped>
.help-center {
  max-width: 1100px;
}
.help-center >>> .el-tabs__header {
  margin-bottom: 16px;
}
.biz-flow {
  max-width: 1100px;
}

.intro {
  margin-bottom: 20px;
}
.intro h2 {
  margin: 0 0 6px;
  font-size: 20px;
  color: #0f172a;
}
.intro p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
}

.flow-block {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 18px 20px 20px;
  margin-bottom: 16px;
}
.flow-block.last {
  margin-bottom: 0;
}
.flow-title {
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 14px;
}

.flow-row {
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 8px;
}
.flow-row.compact .node {
  min-width: 140px;
  flex: 1;
}

.node {
  flex: 1;
  min-width: 150px;
  border-radius: 10px;
  padding: 14px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}
.node.primary {
  background: linear-gradient(180deg, #eff6ff 0%, #f8fafc 100%);
  border-color: #bfdbfe;
}
.node.soft {
  background: #f1f5f9;
  text-align: center;
  padding: 16px 10px;
}
.n-step {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #2563eb;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}
.n-name {
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 6px;
  font-size: 14px;
}
.n-desc {
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
}
.arrow {
  display: flex;
  align-items: center;
  color: #94a3b8;
  font-size: 18px;
  font-weight: 600;
  padding: 0 2px;
}

.roles {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.role-card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  background: #fafbfc;
}
.role-head {
  padding: 10px 14px;
  font-weight: 600;
  font-size: 14px;
  color: #fff;
}
.role-head.pc { background: #2563eb; }
.role-head.app { background: #0d9488; }
.role-head.mp { background: #7c3aed; }
.role-card ul {
  margin: 0;
  padding: 12px 14px 14px 30px;
  color: #475569;
  font-size: 13px;
  line-height: 1.7;
}
.role-flow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px dashed #e2e8f0;
}
.chip {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
}
.chip.pc { background: #2563eb; }
.chip.app { background: #0d9488; }
.chip.mp { background: #7c3aed; }
.arr { color: #94a3b8; font-weight: 600; }

.sub-flows {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.sub-flow {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.sub-label {
  flex: 0 0 52px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 6px;
  background: #0f172a;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}
.sub-steps {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1;
}
.sub-steps span {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
  color: #334155;
}
.sub-steps i {
  font-style: normal;
  color: #94a3b8;
  font-weight: 600;
}

.hint {
  margin: 12px 0 0;
  font-size: 12px;
  color: #94a3b8;
}

@media (max-width: 900px) {
  .roles { grid-template-columns: 1fr; }
  .arrow { display: none; }
  .node { min-width: 100%; }
}
</style>
